module.exports = __webpack_public_path__ + "pic_bizny_web_05-640@2x.png?bafbb8d1cae037a20a9305cbd6ae8202";